<div class="graph-wrapper">
    <div class="header">
        <h4 class="ellipses d-flex">Changeover vs Cost %
            &nbsp;
            <div [popover]="popTemplate1" triggers="mouseenter:mouseleave" container="body" placement="bottom">

                <img src="../../../assets/images/icn-info.svg" alt="">
            </div>
        </h4>
        <div class="minimise" mat-dialog-close></div>
    </div>
    <div #barGrapChangeOverhDiv class="donut" id="barGrapChangeOverhDiv"></div>
</div>
<ng-template #popTemplate1>
    <div class="mb-15">Monthly trend of Format Changeover and Product Changeover against Cost % at the Line level</div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost % =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                total waste cost generated by the Line per month

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost generated by the Line from Year to Date
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>